import { useFavorisStore } from '../../favoris/favorisStore'
import { useVirementRoutingService } from '../../detail/virement/useVirementRoutingService'

export function useRechercheVirementActions() {
  const routingService = useVirementRoutingService()
  const { addFavori } = useFavorisStore()

  function displayVirement(code: string) {
    routingService.navigateToWithKey(code)
  }

  return { addFavori, displayVirement }
}
